<template>
  <div v-loading="dataLoading" ref="transactionDetailsRef" class="transaction-detail-wrapper">
    <template v-if="detailsData">
      <div class="detail-top">
        <div class="title-txt margin-bottom-16">
          <span>{{ $t('message.tableCommon.txnAmount') }}</span>
          <p class="fail-reason" v-if="detailsData.txnStatus === 'F'">
            <span>{{ `Code: ${detailsData.errorCode} | Msg: ${detailsData.errorMsg}` }}</span>
            <template v-if="detailsData.adviceMsg">
              <el-popover placement="left" popper-class="popper-dark" trigger="click">
                <div v-html="detailsData.adviceMsg"></div>
                <template #reference>
                  <img class="margin-left-8" style="vertical-align:sub;width:16px;height:16px;cursor:pointer;"
                    src="@/assets/images/base/icon-note.png" />
                </template>
              </el-popover>
            </template>
          </p>
        </div>
        <div class="amount-box">
          <p>
            <span class="amount-txt">{{ detailsData.txnAmount ? detailsData.txnAmount.amount : '' }}</span>
            <span class="currency-txt">{{ detailsData.txnAmount ? detailsData.txnAmount.currency : '' }}</span>
          </p>
          <p v-if="(detailsData.txnType === '0006' || detailsData.txnType === '0010') && detailsData.txnStatus === 'S' && showRefund && detailsData?.txnAmount?.amount > 0"
            class="btn-box" @click="handleRefund">
            <img class="icon normal" src="@/assets/images/base/icon-redirect.png" />
            <img class="icon active" src="@/assets/images/base/icon-redirect-active.png" />
            <span class="margin-left-4">{{ $t('message.tableCommon.refund') }}</span>
          </p>
        </div>
        <div class="txn-info">
          <div class="txn-item-box margin-right-32">
            <p class="label">{{ $t('message.tableCommon.status') }}</p>
            <p class="value">
              <span v-for="s in statusList" :key="s.value" :class="['status', `status-${s.value}`]">{{ s.label }}</span>
            </p>
          </div>
          <div class="txn-item-box margin-right-32">
            <p class="label">{{ $t('message.tableCommon.txnSerialNumber') }}</p>
            <p class="value">
              <TextView :text="detailsData.txnId" type="copy"></TextView>
            </p>
          </div>
          <div class="txn-item-box margin-right-32">
            <p class="label">{{ $t('message.tableCommon.paymentType') }}</p>
            <p class="value">{{ detailsData.cardBin }}</p>
          </div>
          <div class="txn-item-box">
            <p class="label">{{ $t('message.transaction.txnProcessTime') }}</p>
            <p class="value">{{ detailsData.txnTime }}</p>
          </div>
        </div>
        <!-- <div v-if="!isQueryHistory && (detailsData.txnType === '0006' || detailsData.txnType === '0010') && detailsData.txnStatus === 'S' && showRefund" class="operate-box">
          <el-button size="small" @click="handleRefund">{{$t('message.tableCommon.refund')}}</el-button>
        </div> -->
      </div>
      <div v-if="timelineList.length > 0">
        <RhcnDescriptions contentType="slot" :details-condition="timelineCondition">
          <template slot="content">
            <div class="timeline-box">
              <div v-for="(item, index) in timelineList" :key="index" class="timeline-item">
                <p class="timeline-item-icon margin-top-2 margin-right-25"></p>
                <div class="timeline-item-content">
                  <p class="timeline-item-title" :style="{ color: item.isYellow ? '#FF8000' : '' }">
                    {{ item.txnType }} {{ item.statusName }}
                    <span class="retry_tag"
                      v-if="['7', '8', '9'].includes(JSON.parse(item.additionalData)?.retriedType)">
                      {{ $t('message.status.retry') }}
                    </span>
                    <span v-if="item.isYellow" style="margin-left: 6px;"> ( {{ $t('message.transaction.thisTransion') }}
                      )</span>
                  </p>
                  <p v-if="(!(item.stageCode === 'fraud' && item.statusCode === 'R')&&((item.stageCode === 'refund' && item.statusCode === 'I') || (item.stageCode === 'chargeback' && item.statusCode === 'NEW') || ['7', '8', '9'].includes(JSON.parse(item.additionalData)?.retriedType) || item.isFirst) && !item.isYellow)"
                    class="timeline-item-link">
                    <span class="margin-right-4 margin-top-8">{{ $t('message.transaction.clickNumViewDetails') }}</span>
                    <TextView :text="item.eventId" type="link" @link="onLinkClick(item)"></TextView>
                  </p>
                  <p v-else class="margin-top-4"></p>
                  <p class="timeline-item-time">{{ item.createTime }}</p>
                </div>
                <p class="time-line"></p>
              </div>
              <!-- <div class="expand_btn">
                <div class="box" @click="handleExpand">
                  <span class="expand_btn_txt">
                    Expand all</span>
                  <img :style="expand_btn_style" class="icon" src="@/assets/images/arrow.png" />
                </div>
              </div> -->
            </div>
          </template>

        </RhcnDescriptions>
      </div>
      <!-- 交易信息 -->
      <div class="margin-top-32 margin-bottom-32">
        <RhcnDescriptions :details-condition="transactionCondition"></RhcnDescriptions>
      </div>
      <div class="descriptions-box">
        <div class="descriptions-item">
          <div class="margin-bottom-32">
            <RhcnDescriptions :rowColumn="1" :details-condition="paymentCondition"></RhcnDescriptions>
          </div>
          <div class="margin-bottom-32">
            <RhcnDescriptions :rowColumn="1" :details-condition="threeDSCondition"></RhcnDescriptions>
          </div>
          <div class="margin-bottom-32">
            <RhcnDescriptions :rowColumn="1" :details-condition="riskCondition"></RhcnDescriptions>
          </div>
        </div>
        <div class="descriptions-item margin-left-32">
          <div class="margin-bottom-32">
            <RhcnDescriptions :rowColumn="1" :details-condition="merchantCondition"></RhcnDescriptions>
          </div>
          <div class="margin-bottom-32">
            <RhcnDescriptions :rowColumn="1" :details-condition="billingAddressCondition"></RhcnDescriptions>
          </div>
          <div class="margin-bottom-32">
            <RhcnDescriptions :rowColumn="1" :details-condition="shippingAddressCondition"></RhcnDescriptions>
          </div>
        </div>
      </div>
    </template>
    <!-- 退款弹窗 -->
    <refund-dialog ref="refundDialogRefState" @refresh="onRefresh"></refund-dialog>
  </div>
</template>
<script>

import RhcnDescriptions from '@/components/form/descriptions.vue';
import TextView from '@/components/form/text-view.vue';
import { ShowWarningMessage } from '@/components/modal/tips/message-tips';
import { REQUIRED } from '@/components/validation/tool/validator';
import GlobalData from '@/utils/global/index';
import { getEnantiomericValue, initSelectedData, splicingAmountAndCurrency } from '@/utils/tools/constant';
import { getCurrencyImage } from '@/utils/tools/currency';
import { formatCardNumber } from '@/utils/tools/utils';
import { checkPermission } from '@/views/index/api/index';
import TransitionService from '@/views/transaction/api/transaction-query.service';
import { RefundStatus } from '@/views/transaction/status/transaction';
import RefundDialog from '@/views/transaction/transaction-details/components/refundDialog/index.vue';

export default {
  name: 'TransactionDetails',
  components: {
    RefundDialog,
    RhcnDescriptions,
    TextView,
  },
  data() {
    return {
      dataLoading: false,
      getTransactionDetails: TransitionService.getTransactionDetails,
      postRefundAmount: TransitionService.postRefundAmount,
      getCurrencyImage,
      transactionId: '',
      txnTypeList: [],
      txnStatusList: [],
      refundStatusList: [],
      chargebackStatusList: [],
      txnDetailCondition: [],
      countryList: [],
      transactionCondition: {},
      merchantCondition: {},
      paymentCondition: {},
      threeDSCondition: {},
      riskCondition: {},
      billingAddressCondition: {},
      shippingAddressCondition: {},
      timelineCondition: { topTitle: 'message.transaction.timeline' },
      getEnantiomericValue,
      detailsData: null,
      refundCondition: [
        {
          key: 'amount',
          name: 'message.transaction.requestRefundAmount',
          type: 'input',
          defValue: '',
          isShowStar: true,
          rule: [REQUIRED],
        },
      ],
      showRefund: false,
      isQueryHistory: false,
      timelineList: [],
      statusList: [],
      descriptionsWidth: '',
      expand_btn_style: {
        transform: 'rotate(180deg)',
      },
      timelineListHeightStyle: {
        height: '260px',
        overflow: 'hidden',
      },
    };
  },
  methods: {
    handleExpand() {
      this.expand_btn_style.transform = this.expand_btn_style.transform ? '' : 'rotate(180deg)';
      this.timelineListHeightStyle.height = this.timelineListHeightStyle.height === '260px' ? 'auto' : '260px';
    },
    getAddressTemplate(allData, title) {
      return {
        topTitle: this.$t(title),
        listTemplate: [
          {
            titleBar: { title: 'message.transaction.name' },
            key: 'name',
            textFunc: (data) => (`${data.firstName || ''} ${data.lastName || ''}`),
          },
          {
            titleBar: { title: 'message.tableCommon.email' },
            key: 'email',
          },
          {
            titleBar: { title: 'message.transaction.phone' },
            key: 'phone',
          },
          {
            titleBar: { title: 'message.transaction.address' },
            key: 'address',
            type: 'html',
            textFunc: (data) => {
              const arr = [];
              if (data.city) {
                arr.push(data.city);
              }
              if (data.province) {
                arr.push(data.province);
              }
              if (data.country) {
                arr.push(data.country);
              }
              if (data.postalCode) {
                arr.push(data.postalCode);
              }
              if (data.address) {
                return `${data.address}<br>${arr.join(',')}`;
              }
              return arr.join(',');
            },
          },
        ],
        data: allData,
      };
    },
    getTransactionTemplate(allData) {
      return {
        topTitle: 'message.transaction.info',
        listTemplate: [
          {
            titleBar: { title: 'message.tableCommon.txnSerialNumber' },
            key: 'txnId',
          },
          {
            titleBar: { title: 'message.transaction.txnProcessTime' },
            key: 'txnTime',
          },
          {
            titleBar: { title: 'message.tableCommon.txnType' },
            key: 'txnType',
            textFunc: (data) => getEnantiomericValue(this.txnTypeList, data.txnType),
          },
          {
            titleBar: { title: 'message.transaction.paymentRespCode' },
            key: 'errorCode',
            type: 'text-view',
            textViewType: 'blank_link',
            textViewDesc: this.$t('message.transaction.respCodeList'),
            onLink: () => {
              window.open('https://docs.onerway.com/failure', '_blank');
            },
          },
          {
            titleBar: { title: 'message.tableCommon.orderAmount' },
            key: 'txnAmount',
            textFunc: (data) => splicingAmountAndCurrency(data.txnAmount && data.txnAmount.currency, data.txnAmount && data.txnAmount.amount),
          },
          {
            titleBar: { title: 'message.transaction.paymentRespMsg' },
            key: 'errorMsg',
            type: 'text-view',
            textViewType: 'emphasize',
          },
          {
            titleBar: { title: 'message.tableCommon.refundSucceedAmount' },
            key: 'refundedAmount',
            textFunc: (data) => {
              if (!data.refundedAmount) {
                return '';
              }
              return splicingAmountAndCurrency(data.refundedAmount && data.refundedAmount.currency, data.refundedAmount && data.refundedAmount.amount);
            },
          },
          {
            titleBar: { title: 'message.transaction.advise' },
            key: 'adviceMsg',
          },
        ],
        data: allData,
      };
    },
    getMerchantInfoTemplate(allData) {
      return {
        topTitle: 'message.transaction.merchantDetails',
        listTemplate: [
          {
            titleBar: { title: 'message.tableCommon.merchantOrderNumber' },
            key: 'merchantTxnId',
          },
          {
            titleBar: { title: 'message.tableCommon.merchantOriginalOrderNumber' },
            key: 'merchantTxnOriginalId',
          },
          {
            titleBar: { title: 'message.tableCommon.website' },
            key: 'website',
          },
          {
            titleBar: { title: 'message.tableCommon.appId' },
            key: 'appId',
          },
          {
            titleBar: { title: 'message.tableCommon.products' },
            key: 'products',
          },
          {
            titleBar: { title: 'message.transaction.integrationMethod' },
            key: 'sourceChannel',
          },
        ],
        data: allData,
      };
    },
    getPaymentInfoTemplate(allData) {
      return {
        topTitle: 'message.transaction.paymentDetails',
        listTemplate: [
          {
            titleBar: { title: 'message.tableCommon.productType' },
            key: 'productType',
          },
          {
            titleBar: { title: 'message.tableCommon.subProductType' },
            key: 'subProductType',
          },
          {
            titleBar: { title: 'message.tableCommon.cardType' },
            key: 'cardBin',
          },
          {
            titleBar: { title: 'message.tableCommon.subCardType' },
            key: 'walletTypeCode',
          },
          {
            titleBar: { title: 'message.tableCommon.cardBinCountry' },
            key: 'cardBinCountry',
            textFunc: (data) => data.cardBinCountry ? getEnantiomericValue(this.countryList, data.cardBinCountry) : '--',
          },
          {
            titleBar: { title: 'message.tableCommon.bankCardNo' },
            key: 'cardNumber',
            textFunc: (data) => formatCardNumber(data.cardNumber),
          },
        ],
        data: allData,
      };
    },
    get3DSTemplate(allData) {
      return {
        topTitle: 'message.transaction.threeDS',
        listTemplate: [
          {
            isInternationalization: true,
            titleBar: { title: 'message.tableCommon.require3d' },
            key: 'require3d',
            textFunc: (data) => (data.require3d ? 'message.status.yes' : 'message.status.no'),
          },
          {
            titleBar: { title: 'message.tableCommon.eci' },
            key: 'eci',
            type: 'label-tips',
            text: this.$t('message.transaction.eciHint'),
          },
        ],
        data: allData,
      };
    },
    getRiskTemplate(allData) {
      return {
        topTitle: 'message.transaction.riskDetails',
        listTemplate: [
          {
            titleBar: { title: 'message.tableCommon.ip' },
            key: 'ip',

          },
          {
            titleBar: { title: 'message.tableCommon.userAgent' },
            key: 'userAgent',
          },
          {
            titleBar: { title: 'message.tableCommon.disputePresence' },
            key: 'cbStatus',
            textFunc: (data) => getEnantiomericValue(this.chargebackStatusList, data.cbStatus) || '--',
          },
          {
            titleBar: { title: 'message.tableCommon.notificationOfFraud' },
            key: 'fraudReportId',
          },
        ],
        data: allData,
      };
    },
    async onRefresh() {
      this.dataLoading = true;
      try {
        await this.fetchTransactionDetail();
        await this.fetchTransactionTimelineList();
      } catch (err) {
        //
      }
      this.dataLoading = false;
    },

    async fetchTransactionDetail() {
      await this.getTransactionDetails(this.transactionId, { isHistory: this.$route.query.isHistory || 0 }).then((data) => {
        this.transactionCondition = this.getTransactionTemplate(data);
        if (this.transactionCondition?.data.errorMsg) {
          this.transactionCondition.data.errorMsg = this.transactionCondition.data.errorMsg.charAt(0).toUpperCase() + this.transactionCondition.data.errorMsg.slice(1);
        }
        this.merchantCondition = this.getMerchantInfoTemplate(data);
        this.paymentCondition = this.getPaymentInfoTemplate(data);
        this.threeDSCondition = this.get3DSTemplate(data);
        this.riskCondition = this.getRiskTemplate(data);
        this.billingAddressCondition = this.getAddressTemplate(data.billingInformation, 'message.transaction.billingAddress');
        this.shippingAddressCondition = this.getAddressTemplate(data.shippingInformation, 'message.transaction.mailingAddress');
        let txnStatuses = [];
        if (data.chargebackStatus || data.onlineRefundStatus) {
          if (data.onlineRefundStatus) {
            txnStatuses.push({
              value: data.onlineRefundStatus,
              label: getEnantiomericValue(this.refundStatusList, data.onlineRefundStatus),
            });
          }
          if (data.chargebackStatus) {
            txnStatuses.push({
              value: data.chargebackStatus,
              label: getEnantiomericValue(this.chargebackStatusList, data.chargebackStatus),
            });
          }
        } else {
          txnStatuses = [{
            value: data.txnStatus,
            label: getEnantiomericValue(this.txnStatusList, data.txnStatus),
          }];
        }
        this.statusList = txnStatuses;
        this.detailsData = data;
      });
    },

    async fetchTransactionTimelineList() {
      const res = await TransitionService.queryTransactionTimelineList(this.transactionId);
      // payment 状态为跟f 走前端描述 其他走字典
      this.timelineList = (res || []).map(item => {
        let statusName;
        if (item.stageCode === 'payment') {
          if (item.statusCode === 'R') {
            statusName = this.$t(this.detailsData.productType === 'CARD' ? 'message.transaction.redirectedCard3DS' : 'message.transaction.redirectedLocal');
          } else if (item.statusCode === 'F') {
            statusName = this.$t('message.transaction.paymentFailDesc', { desc: item.paymentFailReason });
          } else {
            statusName = getEnantiomericValue(this.txnStatusList, item.statusCode);
            // 如果是重试交易 这里展示重试的图标
          }
          // refund 状态为跟s且有金额 走前端描述 其他走字典
        } else if (item.stageCode === 'refund') {
          // 退款记录
          if (item.statusCode === 'S' && item.refundAmount) {
            statusName = this.$t('message.transaction.refundSuccessDesc',
              { desc1: splicingAmountAndCurrency(item.refundAmount.currency, item.refundAmount.amount), desc2: this.$t(getEnantiomericValue(RefundStatus, item.isFullRefund)) });
          } else {
            statusName = getEnantiomericValue(this.refundStatusList, item.statusCode);
          }
          // chargeback走字典
        } else if (item.stageCode === 'chargeback') {
          // 拒付记录
          statusName = getEnantiomericValue(this.chargebackStatusList, item.statusCode);
        } else if (item.stageCode === 'fraud') {
          if (item.statusCode === 'R') {
            statusName = this.$t('message.transaction.receivedFraudNotification');
          }
        }
        return {
          ...item,
          statusName,
        };
      });
      // 只显示最新的12条
      // if (this.timelineList.length > 12) {
      //   this.timelineList.splice(12, this.timelineList.length);
      // }
    },
    async initDetailsAll() {
      this.transactionCondition = this.getTransactionTemplate({});
      this.merchantCondition = this.getMerchantInfoTemplate({});
      this.paymentCondition = this.getPaymentInfoTemplate({});
      this.threeDSCondition = this.get3DSTemplate({});
      this.riskCondition = this.getRiskTemplate({});
      this.dataLoading = true;
      try {
        await this.fetchTransactionDetail();
        await this.fetchTransactionTimelineList();
      } catch (err) {
        //
      }
      this.dataLoading = false;
    },
    // 交易状态固定显示
    setTxnStatus(data) {
      if (data.txnType === '0029' && (data.txnStatus === 'P' || data.txnStatus === 'I')) {
        return 'message.status.acceptedSuccess';
      }
      return getEnantiomericValue(this.txnStatusList, data.txnStatus);
    },
    amountJudgment(params) {
      if (!this.detailsData || !this.detailsData.refundAmount || +this.detailsData.refundAmount.amount - +params.amount < 0) {
        ShowWarningMessage(this.$t('message.transaction.maximumRefundAmount') + this.detailsData.refundAmount.amount);
        return false;
      }
      return true;
    },
    getAmountDisplay(data) {
      if (data) {
        return splicingAmountAndCurrency(data.currency, data.amount);
      }
      return '';
    },
    handleRefund() {
      this.$refs.refundDialogRefState.open(this.detailsData.txnId, this.detailsData);
    },
    async initMethod() {
      this.transactionId = this.$route.query.id;
      console.log(this.$route.query, 'this.$route.query');
      checkPermission('transaction:list:refund').then((res) => {
        this.showRefund = res;
      });
      await GlobalData.getDictList(['TXN_TYPE', 'MERC_TXN_STATUS', 'MERC_REFUND_STATUS', 'MERC_CHARGEBACK_STATUS', 'COUNTRY']).then((res) => {
        this.txnTypeList = initSelectedData(res.TXN_TYPE);
        this.txnStatusList = initSelectedData(res.MERC_TXN_STATUS);
        this.refundStatusList = initSelectedData(res.MERC_REFUND_STATUS);
        this.chargebackStatusList = initSelectedData(res.MERC_CHARGEBACK_STATUS);
        this.countryList = (res.COUNTRY || []).map(item => {
          try {
            const lang = this.$store.getters.app.currentLan;
            const arr = item.description.split('-');
            const label = lang === 'zh-cn' ? arr[0] : (arr[1] || arr[0]);
            return {
              label,
              value: item.value,
            };
          } catch (err) {
            //
          }
          return {
            label: item.description,
            value: item.value,
          };
        });
      }).catch(() => {
      });
      this.initDetailsAll();
      this.isQueryHistory = this.$route.query.isHistory === '1';
    },
    onLinkClick(data) {
      const params = {
        id: data.eventId,
      };
      if (this.isQueryHistory) {
        params.isHistory = '1';
      }
      if (data.stageCode === 'refund') {
        this.$router.push({
          path: '/transaction/refund/details',
          query: params,
        });
      } else if (data.stageCode === 'chargeback') {
        this.$router.push({
          path: '/transaction/refuse/details',
          query: params,
        });
      } else {
        // this.$router.push({
        //   path: '/transaction/details?id=' + data.eventId + '&isHistory=1',
        // });
        // console.log('data', data);
        // this.$router.push({
        //   path: '/transaction/details',
        //   query: params,
        // });
        window.location.href = '/transaction/details?id=' + data.eventId + '&isHistory=1';
      }
    },
  },
  mounted() {
    this.initMethod();
    this.descriptionsWidth = `${((this.$refs.transactionDetailsRef.scrollWidth - 32) / 2)}px`;
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/variables.scss';

.transaction-detail-wrapper {
  padding-bottom: 50px;

  :deep(.rhcn-descriptions) {
    .el-descriptions-item__label {
      width: 120px;
      min-width: 120px;
    }
  }
}

html[lang=en] .transaction-detail-wrapper {
  :deep(.rhcn-descriptions) {
    .el-descriptions-item__label {
      width: 160px;
      min-width: 160px;
    }
  }
}

.detail-top {
  margin-bottom: 30px;
  border-radius: 8px;
  border: 1px solid #EFEFF4;
  padding: 24px;

  .title-txt {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    font-family: Avenir-Book, Avenir;
    font-weight: normal;
    color: $color-description-new;
    line-height: 19px;

    .fail-reason {
      display: flex;
      align-items: center;
      font-weight: 500;
      font-size: 14px;
      color: #667085;
      line-height: 18px;

      .icon-tips {
        width: 16px;
        height: 16px;
        margin-left: 8px;
      }
    }
  }

  .amount-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;
    color: $color-text-primary-new;
    font-weight: 800;
    border-bottom: 1px solid #EFEFF4;
    padding-bottom: 16px;

    .amount-txt {
      font-size: 32px;
      line-height: 30px;
      margin-right: 10px;
    }

    .currency-txt {
      color: #667085;
      font-size: 32px;
      font-weight: 400;
    }

    .currency-icon {
      width: 26px;
      margin-right: 38px;
    }

    .status {
      font-size: 14px;
      line-height: 30px;
      padding: 0 8px;
      height: 30px;
      border-radius: 4px;
      background: rgba(252, 100, 45, 0.15);

      &-S {
        background: rgba(0, 221, 40, 0.15);
      }

      &-P,
      &-U {
        background: rgba(255, 178, 9, 0.15);
      }

      &-N {
        background: #F1F5F7;
      }
    }

    .btn-box {
      display: flex;
      align-items: center;
      padding: 0 24px;
      height: 26px;
      border-radius: 8px;
      border: 1px solid #D0D5DD;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      line-height: 18px;
      cursor: pointer;

      .icon {
        width: 12px;
        height: 12px;

        &.active {
          display: none;
        }
      }

      &:hover {
        background: #F6F6FF;
        border: 1px solid $color-primary-new;
        color: $color-primary-new;

        .icon.normal {
          display: none;
        }

        .icon.active {
          display: inline-block;
        }
      }
    }
  }

  .txn-info {
    display: flex;

    .txn-item-box {
      flex: 1;
      border-right: 1px solid #EFEFF4;

      &:last-child {
        border-right: none;
      }

      .label {
        font-weight: 400;
        font-size: 14px;
        color: #667085;
        line-height: 18px;
        margin-bottom: 8px;
      }

      .value {
        font-weight: 400;
        font-size: 14px;
        color: $color-text-primary-new;
        line-height: 18px;
      }
    }

    .status {
      font-weight: bold;
      font-size: 12px;
      line-height: 30px;
      padding: 2px 8px;
      height: 20px;
      border-radius: 20px;
      background: #FFFAEB;
      color: #CC8406;

      &-S,
      &-ACCEPT,
      &-SAS,
      &-FAS,
      &-pass {
        background: #ECFDF3;
        color: #027A48;
      }

      &-F,
      &-SAT,
      &-SAF,
      &-FAT,
      &-FAF,
      &-fail {
        background: #FEF3F2;
        color: #912018;
      }

      &-N,
      &-REVOKE {
        background: #EBEEF1;
        color: #667085;
      }
    }
  }
}

.timeline-box {
  position: relative;
  flex-basis: 100%;
  align-items: center;
  max-height: 400px;
  overflow-y: auto;
  // overflow: scroll;

  .timeline-item {
    position: relative;
    display: flex;
    align-items: flex-start;
    // min-height: 48px;
    padding-bottom: 12px;

    .timeline-item-icon {
      position: relative;
      width: 9px;
      height: 9px;
      border: 1px solid #D9D9D9;
      border-radius: 50%;
      z-index: 1;
      box-sizing: border-box;
      margin-top: 3px;
    }

    .timeline-item-content {
      flex-wrap: wrap;

      .timeline-item-title {
        font-weight: bold;
        font-size: 14px;
        color: $color-black;
        line-height: 16px;

        .retry_tag {
          width: 48px;
          height: 24px;
          background: #FFEBD6;
          border-radius: 20px 20px 20px 20px;
          font-family: "OPPOSans";
          font-weight: bold;
          font-size: 14px;
          color: #FF8000;
          line-height: 16px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          padding: 4px 10px;
        }
      }

      .timeline-item-time {
        font-weight: 400;
        font-size: 12px;
        color: #9EA9C1;
        line-height: 20px;
      }

      .timeline-item-link {
        display: flex;
        align-items: center;
        font-weight: 400;
        font-size: 12px;
        color: #667085;
        line-height: 20px;

        .link {
          cursor: pointer;
          color: $color-text-primary-new;
          margin-top: 7px;

          .iconfont {
            font-size: 8px;
          }
        }
      }

    }

    .time-line {
      position: absolute;
      left: 4px;
      top: 11px;
      height: calc(100% - 8px);
      border-left: 1px solid #EFEFF4;
      z-index: 0;
    }

    &:last-child {
      padding-bottom: 0;

      .time-line {
        height: 0;
      }
    }
  }

  .expand_btn {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    flex-basis: 100%;
    text-align: center;
    cursor: pointer;

    .box {
      display: inline-flex;
      align-items: center;
    }
  }
}

.descriptions-box {
  display: flex;

  .descriptions-item {
    flex: 1;
  }
}
</style>
<style lang="scss">
@import '@/styles/variables.scss';

.margin-top-8 {
  margin-top: 8px;
}

.refund-amount-info {
  padding: 12px 14px 0;
  background-color: $color-default;
  border-radius: 2px;

  .el-descriptions__body {
    background-color: $color-default;

    .el-descriptions-item__label {
      font-size: 14px;
      line-height: 20px;
      padding-bottom: 0;
      color: $color-text-primary;
    }

    .el-descriptions-item__content {
      font-size: 14px;
      font-weight: 800;
      color: $color-text-primary;

    }
  }

  margin-bottom: 30px;
}
</style>
